import { Superscript } from '@tiptap/extension-superscript';
import { markInputRule, markPasteRule } from '@tiptap/core';

// Match text with two carets on either side
// Example: ^^superscript^^
const inputRegex = /(?:^|\s)((?:\^\^)((?:[^^]+))(?:\^\^))$/;
const pasteRegex = /(?:^|\s)((?:\^\^)((?:[^^]+))(?:\^\^))/g;

export const CustomSuperscript = Superscript.extend({
   addInputRules() {
      return [
         markInputRule({
            find: inputRegex,
            type: this.type,
         }),
      ];
   },

   addPasteRules() {
      return [
         markPasteRule({
            find: pasteRegex,
            type: this.type,
         }),
      ];
   },
});
